import { useEffect, useState } from "react";
import api from "../API";
import { iSFDefault } from "../interfaceSFClient";

import './Defaults.css';
import { euros } from "../util";
import { useAppDispatch } from "../app/hooks";
import { setTitle } from "../app/appSlice";

const DAY_MILLIS = 24 * 60 * 60 * 1000;

interface iDefaultRow {
    row: iSFDefault;
}

function DefaultRow({ row }: iDefaultRow) {
    return (
        <tr>
            <td>{row.Auftragsdatum}</td>
            <td>{row.Kundennummer}</td>
            <td>{row.LastName}</td>
            <td className="Vorname">{row.FirstName}</td>
            <td className="Offen">{euros(row.Offen)}</td>
        </tr>
    );
}

export default function Defaults() {

    const [from, setFrom] = useState<string>("");
    const [to, setTo] = useState<string>("");

    const [data, setData] = useState<iSFDefault[]>([]);

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(setTitle("Schuldner"));
    });

    useEffect(() => {
        async function load() {
            const days = Math.ceil((new Date().getTime() - new Date(from).getTime()) / DAY_MILLIS);
            const reply = await api.loadDefaults(days);
            if (reply.success) {
                setData(reply.saeumige);
            }
        }
        if (from && to) load();
        if (!from) {
            const from = new Date();
            from.setMonth(0);
            from.setDate(1);
            setFrom(from.toISOString().substring(0, 10));
        }
        if (!to) setTo(new Date().toISOString().substring(0, 10));
    }, [from, to]);

    const sorted = [...data].sort((a, b) => a.Auftragsdatum < b.Auftragsdatum ? -1 : 1);

    return (
        <div className="Defaults">
            <h2>Schuldner</h2>
            <h3>Datum der Dienstleistung</h3>
            <p>
                von <input type="date" value={from} onChange={e => setFrom(e.target.value)} />{" "}
                bis <input type="date" value={to} onChange={e => setFrom(e.target.value)} />
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Auftragsdatum</th>
                        <th>Kundennr.</th>
                        <th>Nachname</th>
                        <th>Vorname</th>
                        <th>Offen</th>
                    </tr>
                </thead>
                <tbody>
                    {sorted.map(row => <DefaultRow key={row.Id} row={row} />)}
                </tbody>
            </table>
        </div>
    );

}